import { get } from 'lodash';
import { createSelector } from 'reselect';

export const allParentDomainIdsSelector = state => get( state, 'unclaimedDomainsWithCounts.allParentDomainIds', [] );
export const byIdSelector = state => get( state, 'unclaimedDomainsWithCounts.byId', {} );
export const unclaimedDomainsWithCountsIsLoadingSelector = state => get( state, 'unclaimedDomainsWithCounts.isLoading', false );

// Params
export const unclaimedParamsSelector = state => get( state, 'unclaimedDomainsWithCounts.params', null );
export const unclaimedFilterParamsSelector = state => get( state, 'unclaimedDomainsWithCounts.filterParams', null );

// Pagination
export const unclaimedCurrentPageSelector = state => get( state, 'unclaimedDomainsWithCounts.pagination.currentPage', 1 );
export const unclaimedTotalPagesSelector = state => get( state, 'unclaimedDomainsWithCounts.pagination.totalPages', 1 );
export const unclaimedTotalItemsSelector = state => get( state, 'unclaimedDomainsWithCounts.pagination.totalItemCount', 0 );

export const unclaimedParentDomainsWithCountsSelector = createSelector(
    allParentDomainIdsSelector,
    byIdSelector,
    ( parentDomainIds, domainMap ) => parentDomainIds.map( id => domainMap[id] )
);
